import React, { useEffect, useRef, useContext, useState } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import Button from "../../components/button";
import { FontSizeContext } from "../../context/fontSizeContext";

const ServiceProviderAddressContainer = ({ mainData, contRef }) => {
    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);
    }, []);
    return (
        <div className="single-service" ref={contRef}>
            <div
                className={
                    mainData.classOptionTop + " justify-content-center pt-5"
                }
            >
                <div className="container">
                    <div className="row">
                        {mainData ? (
                            <div
                                key={mainData.id}
                                className={
                                    mainData.classOption +
                                    " align-content-center radius-box p-2"
                                }
                            >
                                <h3 className="text-primary mb-3 title">
                                    <b>{mainData.zone}</b>
                                </h3>
                            </div>
                        ) : (
                            ""
                        )}
                        {mainData &&
                            mainData.subBranch.map((data, key) => {
                                return (
                                    <a
                                        key={key}
                                        className={data.classOption}
                                        href={data.location}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <h4 className="text-primary mb-1 title ">
                                            <b>{data.city} </b>
                                        </h4>
                                        <p className="b-color mb-3 ">
                                            {data.state}
                                        </p>
                                        <span
                                            className="d-color"
                                            style={{ fontSize: "14px" }}
                                            dangerouslySetInnerHTML={{
                                                __html: data.address,
                                            }}
                                        ></span>
                                    </a>
                                );
                            })}
                    </div>
                </div>
            </div>
        </div>
    );
};

ServiceProviderAddressContainer.propTypes = {
    mainData: PropTypes.any,
    contRef: PropTypes.any,
};

export default ServiceProviderAddressContainer;
